const ALPHABET = "abcdefghijkmnopqrstuvwxyz23456789";
const GROUP = 4;
const GROUPS = 3;

export function generateRoomCode(): string {
  const bytes = new Uint8Array(GROUP * GROUPS);
  crypto.getRandomValues(bytes);

  const letters = Array.from(bytes, (byte) => ALPHABET[byte % ALPHABET.length] ?? "x");
  const groups: string[] = [];

  for (let index = 0; index < GROUPS; index += 1) {
    groups.push(letters.slice(index * GROUP, index * GROUP + GROUP).join(""));
  }

  return groups.join("-");
}

export function normalizeRoomCode(input: string): string {
  const tail = input.trim().split("/").pop() ?? "";
  return tail.toLowerCase().replaceAll(/[^a-z0-9]/gu, "");
}

export function isValidRoomCode(input: string): boolean {
  return normalizeRoomCode(input).length === GROUP * GROUPS;
}

export function formatRoomCode(input: string): string {
  const raw = normalizeRoomCode(input);
  const groups: string[] = [];

  for (let index = 0; index < raw.length; index += GROUP) {
    groups.push(raw.slice(index, index + GROUP));
  }

  return groups.join("-");
}
